import React from 'react';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();

  const handleClick = () => {
      navigate('/');
  };

  return (
    <div className="form-container">
      <div className="form-card">
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
          <h1>401 - Unauthorized</h1>
          <p>You do not have permission to access this page.</p>
        </div>
        <div className="form-actions">
          <button type="button" className="btn-save" onClick={handleClick}>
            Retour à l'accueil
          </button>
        </div>
      </div>
    </div>
  );
}
 

export default Unauthorized;
